/// <reference path="api.d.ts" />

namespace API.Client {
    'use strict';

    export interface BanksResponse {

        "banks"?: Array<Bank>;
    }

}
